import { LegendEntryStyle, LegendStyle } from "./styles/styles";

export type TLegendEntry = {
    color: string,
    text: string
}

type TProps = {
    entries: TLegendEntry[]
}

const Legend = ({ entries }: TProps) => {
    return (
        <div style={LegendStyle} >
            {entries.map((e, i) => <span key={i}><span style={{...LegendEntryStyle, backgroundColor: e.color}}>&nbsp;</span> - {e.text}&nbsp;</span>)}
        </div>
    );
}

export default Legend;